import ApiService from '@/services/core/api.service'

const CommentService = {
  async get (payment, params = {}) {
    return ApiService.get(`accounts-payable-accountant/payment-postings/${payment}/comments`, { params })
  },

  async post (payment, payload) {
    return ApiService.post(`accounts-payable-accountant/payment-postings/${payment}/comments`, payload)
  },

  async put (payment, payload) {
    return ApiService.put(`accounts-payable-accountant/payment-postings/${payment}/comments/${payload.id}`, payload)
  },

  async delete (payment, payload) {
    return ApiService.delete(`accounts-payable-accountant/payment-postings/${payment}/comments/${payload.id}`, {
      data: payload
    })
  }
}

export default CommentService
